import MyAccountChangePlanModal from './MyAccountChangePlanModal'

export default MyAccountChangePlanModal
// eslint-disable-next-line import/export
export * from './MyAccountChangePlanModal'
